<template>

  <!-- start copyright -->
  <footer id="copyright">
    <div class="container">
      <!-- <div class="row"> -->
        <!-- <div class="col-md-12 text-center"> -->
          <p class="wow bounceIn" style="color: white;" data-wow-offset="50" data-wow-delay="0.3s">深圳卓然软件有限公司  版权所有 粤ICP备2023011215号
          </p>
        <!-- </div> -->
      <!-- </div> -->
    </div>
  </footer>
  <!-- end copyright -->
</template>

<script>
import {getisMobile}from'@/utils/utils'
export default {
  name: 'HelloWorld',
  data() {
    return {
      isMobile:getisMobile()
    };
  },
  created() {

  },
  methods: {

  },
}
</script>

<style lang="scss">
@import 'animate.css';
.el-footer{
  background-color: #272727;
}

@media screen and (max-width: 600px) {
  .el-footer{
    padding:0 !important;
  }
  #copyright{
    background:#181818;
    
    p{
      font-size:12px;
    }
  }
}
</style>
